import React, { useRef, useState } from 'react';
import { capitalCase } from 'change-case';
import {
  Badge,
  Box,
  Button,
  IconButton,
  Popover,
  SvgIcon,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Settings as SettingsIcon } from 'react-feather';
import useSettings from 'src/hooks/useSettings';
import { LANGUAGE, THEMES } from 'src/constants';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  badge: {
    height: 10,
    width: 10,
    borderRadius: 5,
    marginTop: 10,
    marginRight: 5,
  },
  popover: {
    width: 320,
    padding: theme.spacing(2),
  },
}));

function Settings() {
  const { t, i18n } = useTranslation();
  const classes = useStyles();
  const ref = useRef(null);
  const { settings, saveSettings } = useSettings();
  const [isOpen, setOpen] = useState(false);
  const [values, setValues] = useState({
    direction: settings.direction,
    responsiveFontSizes: settings.responsiveFontSizes,
    theme: settings.theme,
    language: settings.language,
  });

  const handleChangeLanguage = (value) => {
    i18n.changeLanguage(value);
    setValues({
      ...values,
      language: value,
    });
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (field, value) => {
    setValues({
      ...values,
      [field]: value,
    });
  };

  const handleSave = () => {
    saveSettings(values);
    setOpen(false);
  };

  return (
    <>
      <Tooltip title={t('Settings')}>
        <Badge
          classes={{ badge: classes.badge }}
          color="secondary"
          overlap="rectangular"
          variant="dot"
        >
          <IconButton
            ref={ref}
            color="#7a7b74"
            onClick={handleOpen}
            size="large"
          >
            <SvgIcon fontSize="small">
              <SettingsIcon />
            </SvgIcon>
          </IconButton>
        </Badge>
      </Tooltip>
      <Popover
        anchorEl={ref.current}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        classes={{ paper: classes.popover }}
        onClose={handleClose}
        open={isOpen}
      >
        <Typography color="textPrimary" variant="h4">
          {t('Settings')}
        </Typography>
        {/* <Box
        mt={2}
        px={1}
      >
        <FormControlLabel
          control={(
            <Switch
              checked={values.direction === 'rtl'}
              edge="start"
              name="direction"
              onChange={(event) => handleChange('direction', event.target.checked ? 'rtl' : 'ltr')}
            />
          )}
          label={t("Lateral Menu")}
        />
      </Box>
      <Box
        mt={2}
        px={1}
      >
        <FormControlLabel
          control={(
            <Switch
              checked={values.responsiveFontSizes}
              edge="start"
              name="direction"
              onChange={(event) => handleChange('responsiveFontSizes', event.target.checked)}
            />
          )}
          label="Responsive font sizes"
        />
      </Box> */}
        <Box mt={2}>
          <TextField
            fullWidth
            label={t('brandTheme')}
            name="theme"
            onChange={(event) => handleChange('theme', event.target.value)}
            select
            SelectProps={{ native: true }}
            value={values.theme}
            variant="outlined"
          >
            {Object.keys(THEMES).map((theme) => (
              <option key={theme} value={theme}>
                {t(capitalCase(theme))}
              </option>
            ))}
          </TextField>
        </Box>

        <Box mt={2}>
          <TextField
            fullWidth
            label={t('Change language')}
            name="ChangeLanguage"
            onChange={(event) => handleChangeLanguage(event.target.value)}
            select
            SelectProps={{ native: true }}
            value={i18n.language}
            variant="outlined"
          >
            {LANGUAGE.map((option) => (
              <option key={option.value} value={option.value}>
                {option.description}
              </option>
            ))}
          </TextField>
        </Box>
        <Box mt={2}>
          <Button
            color="secondary"
            fullWidth
            onClick={handleSave}
            variant="contained"
          >
            {t('saveSettings')}
          </Button>
        </Box>
      </Popover>
    </>
  );
}

export default Settings;
